import _ from "lodash";
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';

function MLWizardNavUtil(props) {
    const {
        steps,
        currentStepIndex
    } = props;

    const nextStepVisited = () => {
        return steps[currentStepIndex+1].visited;
    };

    const isLastStep = () => {
        return currentStepIndex === steps.length - 1;
    }

    const canShowReturnToQuoteButton = async (submissionVM, authHeader, quoteStep) => {
        const policyState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
        const isQuotedStatus = _.get(submissionVM, 'baseData.status_ML.value') === 'Quoted';
        let quoteStepVisited = true;
        if (quoteStep) {
            quoteStepVisited = quoteStep.visited;
        }

        const settingsResp = await MLPortalSettingsService.getSettings(authHeader);
        if (!settingsResp) {
            return false
        }

        const { linearWorkflowSettings } = settingsResp;
        const { portalReturnToQuoteEnabled, portalReturnToQuoteStates } = linearWorkflowSettings;

        return portalReturnToQuoteEnabled && isQuotedStatus && quoteStepVisited && (_.isUndefined(portalReturnToQuoteStates) || portalReturnToQuoteStates.indexOf(policyState)>-1);
    };

    return {
        nextStepVisited,
        canShowReturnToQuoteButton,
        isLastStep
    };
}

export default MLWizardNavUtil;
